import { render, staticRenderFns } from "./UserApplicationContainer.vue?vue&type=template&id=45c7564e&scoped=true&"
import script from "./UserApplicationContainer.vue?vue&type=script&lang=js&"
export * from "./UserApplicationContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserApplicationContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserApplicationContainer.vue?vue&type=style&index=1&id=45c7564e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7564e",
  null
  
)

export default component.exports